import { render, staticRenderFns } from "./Medical.vue?vue&type=template&id=1c0c8c01&scoped=true"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"
import style0 from "./Medical.vue?vue&type=style&index=0&id=1c0c8c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c8c01",
  null
  
)

export default component.exports